import React, {useEffect, useState} from 'react';
import TemperatureCard from '../../components/cards/temperature-card/temperature-card';
import HumidityCard from '../../components/cards/humidity-card/humidity-card';
import TemperatureLineCard from '../../components/cards/temperature-line-card/temperature-line-card';
import SignalsCard from '../../components/cards/signals-card/signals-card';
import { useTranslation } from 'react-i18next';
import {getState} from "../../services/state";
import TransmiterCard from "../../components/cards/transmiter-card/transmiter-card";
import Loader from "react-loader-spinner";
import {getAllNames} from "../../services/names.service";
import {optionalMenuDevice} from "../settings-view/optional-menu-items";
import _ from "lodash";
import {getLastValues, testLambda} from "../../services/sensorData.service";
import VoltageInputCard from "../../components/cards/power-card/voltage-input";
import PowerConsumptionCard from "../../components/cards/power-card/power-consumption";
import RelaysCard from "../../components/cards/relays-card/relays-card";
import { getGeneralSettings } from '../../services/generalSettings.service';

interface DefaultCardProps {
    name: string;
    key: string;
    value: number;
}
interface SignalProps {
    name: string;
    key: string;
    value: boolean;
}
interface MainPropsValues {
    temperatures: DefaultCardProps[];
    humidity: DefaultCardProps[];
    inputs: SignalProps[];
    irda: SignalProps[];
    relays: SignalProps[]
}

const testData: MainPropsValues = {
    temperatures: [
        {key: 'temp1', name: 'temp1', value: 20},
        {key: 'temp2', name: 'temp2', value: 20},
        {key: 'temp3', name: 'temp3', value: 20},
        {key: 'temp4', name: 'temp4', value: 20},
        {key: 'temp5', name: 'temp5', value: 20},
        {key: 'temp6', name: 'temp6', value: 20},
    ],
    humidity: [
        {key: 'humidity1', name: 'humidity1', value: 30},
    ],
    inputs: [
        {key: 'input1', name: 'input1', value: true},
        {key: 'input2', name: 'input2', value: true},
        {key: 'input3', name: 'input3', value: true},
        {key: 'input4', name: 'input4', value: true},
        {key: 'input5', name: 'input5', value: true},
        {key: 'input6', name: 'input6', value: true}
    ],
    irda: [
        {key: 'irda1', name: 'irda1', value: true},
        {key: 'irda2', name: 'irda2', value: true},
        {key: 'irda3', name: 'irda3', value: true},
        {key: 'irda4', name: 'irda4', value: true}
    ],
    relays: [
        {key: 'relay1', name: 'relay1', value: true},
        {key: 'relay2', name: 'relay2', value: true},
        {key: 'relay3', name: 'relay3', value: true},
        {key: 'relay4', name: 'relay4', value: true},
        {key: 'relay5', name: 'relay5', value: true},
    ]
}

const voltage = {
    key: 'voltage', value: 0
}

const powerConsumption = {
    key: 'powerConsumption', value: 0
}

const MainView: React.FC = () => {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [names, setNames] = useState({});
    const [lastValues, setLastValues] = useState({});
    const [intervalTime, setIntevalTime] = useState(0)
    const getCharWidth = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 800) {
            return screenWidth;
        }
        return 800;
    }
    const getCurrentValue = (key: string) => {
        return _.get(lastValues, key, 0);
    }

    useEffect(() => {
        getGeneralSettings().then((res) => {
            const infoSendingTime = parseInt(_.get(res, 'infoSendingTime', '0'))
            setIntevalTime(infoSendingTime)
        })
    }, [])

    useEffect(() => {
        if (intervalTime) {
            const interval = setInterval(() => {
                getLastValues().then((res) => setLastValues(res || {}))
            }, intervalTime * 1000 * 60);
            return () => clearInterval(interval);
        }
        
      }, [intervalTime]);
    useEffect(() => {
        Promise.all([getAllNames(), getLastValues()])
            .then(
            (res) => {
                setNames(res[0]);
                testData.temperatures.map((item) => {
                    _.assign(item, {
                        name: _.get(res[0], 'temperature.' + item.key, item.key)
                    })
                    return item;
                });
                testData.humidity.map((item) => {
                    _.assign(item, {
                        name: _.get(res[0], 'humidity.' + item.key, item.key)
                    })
                    return item;
                });
                testData.inputs.map((item) => {
                    _.assign(item, {
                        name: _.get(res[0], 'inputs.' + item.key, item.key)
                    })
                    return item;
                });
                testData.irda.map((item) => {
                    _.assign(item, {
                        name: _.get(res[0], 'irda.' + item.key, item.key)
                    })
                    return item;
                });
                testData.relays.map((item) => {
                    _.assign(item, {
                        name: _.get(res[0], 'relays.' + item.key, item.key)
                    })
                    return item;
                });
                setLastValues(res[1] || {});
                setLoading(false);
            }
        )
            .catch((err) => setLoading(false))
    }, [])
    if(!loading) {
        return (
            <div className='controler-view' id='controler-view'>
                <div className='controler-view w-100'>
                    {
                        testData.temperatures.map((temp, index) => <TemperatureCard index={index + 1} name={t(temp.name)} value={getCurrentValue(temp.key)}/>)
                    }
                    <div className='d-flex flex-column justify-content-between sm-card-view'>
                        {
                            testData.humidity.map((h) => <HumidityCard name={t(h.name)} value={getCurrentValue(h.key)}/>)
                        }
                    </div>
                </div>
                <div className='controler-view w-100'>
                    <div className='d-flex flex-column justify-content-between'>
                        <SignalsCard signals={testData.inputs} name={t('signalInputs')} values={lastValues}/>
                    </div>
                    <div className='d-flex flex-column justify-content-between'>
                        <TransmiterCard irda={testData.irda} name={t('transmiters')} values={lastValues} />
                    </div>
                    <div className='d-flex flex-column justify-content-between'>
                        <RelaysCard signals={testData.relays} name={t('relaysValues')} values={lastValues}/>
                    </div>
                    {/* <div className='d-flex flex-column justify-content-between sm-card-view'> */}
                        {/* <VoltageInputCard name={t(voltage.key)} value={getCurrentValue('voltageInput')}/> */}
                        {/* <PowerConsumptionCard name={t(powerConsumption.key)} value={getCurrentValue('Power')}/> */}
                    {/* </div> */}
                    <TemperatureLineCard allNames={names} names={testData.temperatures} width={getCharWidth()} name='temperature'/>
                </div>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
};

export default MainView;
